<template>
  <div class="card settings_menu">
    <div class="card-header">
      <h4 class="card-title">Settings</h4>
    </div>
    <div class="card-body">
      <ul>
        <li class="nav-item">
          <router-link
            to="/settings"
            class="nav-link"
            :class="activeSetting === 1 && 'active'"
          >
            <i class="la la-user"></i>
            <span>Edit Profile</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/settings-preferences"
            class="nav-link"
            :class="activeSetting === 2 && 'active'"
          >
            <i class="la la-cog"></i>
            <span>Preferences</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/settings-security"
            class="nav-link"
            :class="activeSetting === 3 && 'active'"
          >
            <i class="la la-lock"></i>
            <span>Security</span>
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/settings-account"
            class="nav-link"
            :class="activeSetting === 4 && 'active'"
          >
            <i class="la la-university"></i>
            <span>Linked Account</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeSetting: Number,
  },
};
</script>
